import { render } from "./EditorialDetail.vue?vue&type=template&id=ff593174"
import script from "./EditorialDetail.vue?vue&type=script&lang=js"
export * from "./EditorialDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__